// Imports ------------------------------------------------------------------->

import { Component } from '../Component'
import { element } from '../CustomElement'

import { inject } from '../../services/di'
import { AuthenticationService } from '../../services/AuthenticationService'
import { ConfigService } from '../../services/ConfigService'
import { icons } from '../../icons/Icons'
import { i18n } from '../../i18n/I18n'
import { Link } from '../flipp-link/Link'
import { LinkService } from '../../services/LinkService'
import { EventService } from '../../services/EventService'
import { AnalyticsService } from '../../services/AnalyticsService'
import { FormInput } from '../flipp-form-input/FormInput'
import {
    handleFormInputsChange,
    handleSubmitRequest,
    hasEmptyFields,
    setDocumentTitle,
} from './Login.helper'

@element('flipp-confirm-change-password-page')
export class ConfirmChangePasswordPage extends Component<any, void> {
    @inject config: ConfigService
    @inject auth: AuthenticationService
    @inject eventService: EventService
    @inject analytics: AnalyticsService

    refs: {
        submitForm: HTMLFormElement
        submitBtn: HTMLElement
        spinner: HTMLElement
        codeInput: FormInput
        passwordInput: FormInput
        confirmPasswordInput: FormInput
        submitBtnText: HTMLElement
        responseErrorMsg: HTMLElement
    }

    state = {
        confirmation_code: '',
        password: '',
        confirm_password: '',
    }

    onCreate() {
        setDocumentTitle(i18n('confirm_change_password_header'))
    }

    onAttach() {
        document.title = `${i18n('confirm_change_password_header')} | Flipp`
        this.state.confirmation_code = ''
        this.state.password = ''
        this.state.confirm_password = ''
    }

    render() {
        return (
            <main>
                <div class="top-bar">
                    <Link to="listing" class="flipp-logo" title="Flipp">
                        {icons.flippLogoWhite}
                    </Link>
                </div>
                <div class="one-column-content">
                    <div class="one-column-picture">
                        <img
                            src={`https://f.wishabi.net/creative/Distribution/images/verify-email.svg`}
                            alt=""
                        />
                    </div>
                    <div class="header">
                        {i18n('confirm_change_password_header')}
                    </div>
                    <div class="one-column-text">
                        {i18n('confirm_change_password_text')}
                    </div>
                    <div class="one-column-form">
                        <form name="submitForm" ref="submitForm">
                            <FormInput
                                ref="codeInput"
                                name={'confirmation_code'}
                                handleChange={this.handleChange}
                                type={'text'}
                                placeholder={i18n('confirm_email_code')}
                            />
                            <FormInput
                                ref="passwordInput"
                                name={'password'}
                                handleChange={this.handleChange}
                                type={'password'}
                                placeholder={i18n('new_password')}
                            />
                            <FormInput
                                ref="confirmPasswordInput"
                                name={'confirm_password'}
                                handleChange={this.handleChange}
                                type={'password'}
                                placeholder={i18n('confirm_password')}
                            />
                            <div
                                ref="underButtonText"
                                class="one-column-text under-button-text hide"
                            >
                                <span>
                                    {i18n('confirm_email_under_button_text')}
                                </span>
                            </div>
                            <div class="button-container">
                                <button
                                    ref="submitBtn"
                                    class="flipp-button"
                                    onClick={this.handleSubmit}
                                >
                                    <div
                                        ref="spinner"
                                        class="spinner hide"
                                    ></div>
                                    <div
                                        ref="submitBtnText"
                                        class="submit-button-text"
                                    >
                                        {i18n('signin')}
                                    </div>
                                </button>
                                <p ref="responseErrorMsg" class="error-msg"></p>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        )
    }

    private confirmChangePassword = async () => {
        const urlParams = new URLSearchParams(window.location.search)
        const email = decodeURIComponent(urlParams.get('email'))
        await this.auth.confirmChangePassword({
            email,
            password: this.state.password,
            confirmation_code: this.state.confirmation_code,
        })
        const linkService = LinkService.getInstance()
        linkService.execute('weekly_ads', this)
    }

    private handleChange = (e: any) => {
        this.state = handleFormInputsChange(this.state, this.refs, e)
    }

    private handleSubmit = async (e: any) => {
        e.preventDefault()
        this.refs.responseErrorMsg.textContent = ''
        if (hasEmptyFields(this.state)) {
            if (this.state.confirmation_code.length === 0) {
                this.refs.codeInput.errorMessage = i18n(
                    'enter_confirmation_code_error'
                )
            }
            if (this.state.password.length === 0) {
                this.refs.passwordInput.errorMessage = i18n(
                    'enter_password_error'
                )
            }
            if (this.state.confirm_password.length === 0) {
                this.refs.confirmPasswordInput.errorMessage = i18n(
                    'confirm_password_error'
                )
            }
        }
        if (
            this.state.password &&
            this.state.confirm_password &&
            this.state.password !== this.state.confirm_password
        ) {
            this.refs.confirmPasswordInput.errorMessage = i18n(
                'passwords_mismatch_error'
            )
        } else if (!hasEmptyFields(this.state)) {
            await handleSubmitRequest(this.refs, this.confirmChangePassword)
        }
    }
}
